export const theme = { 
    app: {
        background: '#F6F6F6',
    },
    buttons: {
        primary: {
            background: '#F2BC57', 
            color: '#000000',
            font: 'Sequel 100 Wide 95',
            inactive: {
                background: '#DFDFDF', 
            }
        },
        secondary: {
            background: '#FEFFFE', 
            color: '#000000',
            font: 'Sequel 100 Wide 95',
        },
        tertiary: {
            background: '#44405B', 
            color: '#FEFFFE',
            font: 'Helvetica',
        },
    }, 
    text: {
        color: '#000000',
        font: 'Sequel 100 Wide 95'
    },
    footer: {
        background: '#48445C'
    },
    select: {
        background: '#1A1826',
    },
    checkout: {
        background: '#FEFFFE',
        text: '#1A1826',
        payment: {
            background: '#EAEAEA',
        },
        methods: {
            active: {
                background: '#131312',
                color: '#FEFFFE'
            },
            inactive: {
                background: '#EAEAEA',
                color: '#131312,'
            },
            border: '#B9B9B9'
        },
        navigation: {
            background: '#FEFFFE'
        },
        divider: {
            color: '#E1E0E0'
        }
    },
    error: {
        background: '#FB918E',
        color: '#002152'
    },
    success: {
        background: '#38A368',
        color: '#FEFFFE'
    },
    info: {
        background: '#FEFFFE',
        color: '#002152'
    },
    numbers: {
        background: '#FEFFFE',
        divider: '#C6C6C6',
        font: 'Sequel 100 Wide 95'
    },
    loader: { 
        background: '#000000',
        container: '#FEFFFE',
        circle: '#32C770',
    },
    input: {
        background: '#FEFFFE',
        color: '#ABCDEF'
    },
    balance: {
        background: '#1A2131',
        color: '#FEFFFE'
    }
};